// extracted by mini-css-extract-plugin
export default {"container":"NotFound__container--uJDZopmgUF0gVCOnQZ16","image":"NotFound__image--AuJIwF58tR_AcOxb6Wy3"};